export default __webpack_public_path__ + "static/media/pickshareScreens-mobile.3b5d87cb.png";